import { useNavigate } from 'react-router-dom';
import classes from '../../style/Main.module.css';

const ShopArea = () => {

    const navigate = useNavigate();

    return (
        <div className={classes.main_shop_area}>
                <div className={classes.main_shop_title}>
                    Gear
                </div>
                <div className={classes.main_shop_item_area}>

                    <a className={classes.main_shop_item} href='https://www.rokkitwear.com/school/56250-back-to-basics-movement-and-training?q=hoody' target="_blank" rel="noreferrer" >
                        <img className={classes.main_shop_item_image} src={require('../../images/products/hoody_2.jpg')}/>
                        <div className={classes.main_shop_item_info}>
                            <div className={classes.main_shop_item_name}>
                                Hoody
                            </div>
                            <div className={classes.main_shop_item_price}>
                                $53.99
                            </div>
                        </div>
                    </a>

                    <a className={classes.main_shop_item} href='https://www.rokkitwear.com/school/56250-back-to-basics-movement-and-training?q=tshirt' target="_blank" rel="noreferrer" >
                        <img className={classes.main_shop_item_image} src={require('../../images/products/tshirt_2.jpg')}/>
                        <div className={classes.main_shop_item_info}>
                            <div className={classes.main_shop_item_name}>
                                T-Shirt
                            </div>
                            <div className={classes.main_shop_item_price}>
                                $28.99
                            </div>
                        </div>
                    </a>

                    <a className={classes.main_shop_item} href='https://www.rokkitwear.com/school/56250-back-to-basics-movement-and-training?q=tank' target="_blank" rel="noreferrer" >
                        <img className={classes.main_shop_item_image} src={require('../../images/products/tanktop_2.jpg')}/>
                        <div className={classes.main_shop_item_info}>
                            <div className={classes.main_shop_item_name}>
                                Tank Top
                            </div>
                            <div className={classes.main_shop_item_price}>
                                $27.99
                            </div>
                        </div>
                    </a>
                    
                </div>
        </div>
    )
}

export default ShopArea;